import { Navigate, useParams } from 'react-router';

/**
 * /surveys/:id/results predates the details hub.
 *
 * Results is now a tab on the hub rather than a screen of its own, but the old
 * URL is linked from the library row menu and may well be bookmarked, so it is
 * kept and resolved to the tab instead of being deleted. One canonical URL,
 * no dead link.
 */
export const SurveyResultsRedirect = () => {
  const { id } = useParams();
  if (!id) return <Navigate to="/surveys/library" replace />;
  return <Navigate to={`/surveys/${id}?screen=results`} replace />;
};
